module.exports = __webpack_public_path__ + "static/img/kc1.1b8c4f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kc1.png
// module id = XNzw
// module chunks = 1